import React, { createContext, useContext, useState, useEffect } from "react";
import localforage from "localforage";
const MoreStockContext = createContext();

export const MoreStockProvider = ({ children }) => {
  const [data, setData] = useState([]);

  //   const setMoreData = (data) => {
  //     setData(data);
  //   };
  // const [data, setData] = useState(() => {
  //   const savedData = localStorage.getItem("appData");
  //   return savedData ? JSON.parse(savedData) : [];
  // });
  // const [data, setData] = useState(() => {
  //   const savedData = localforage.getItem("appData");
  //   return savedData ? JSON.parse(savedData) : [];
  // });
  useEffect(() => {
    const loadData = async () => {
      try {
        const savedData = await localforage.getItem("appData");

        if (savedData) {
          setData(savedData); // ✅ already parsed object
        }
      } catch (err) {
        console.error("Error loading data from localforage", err);
      }
    };

    loadData();
  }, []);

  const setMoreData = (newData) => {
    setData(newData);
  };

  // useEffect(() => {
  //   localStorage.setItem("appData", JSON.stringify(data));
  // }, [data]);
  // useEffect(() => {
  //   localforage.setItem("appData", JSON.stringify(data));
  // }, [data]);
  useEffect(() => {
    localforage.setItem("appData", data);
  }, [data]);
  return (
    <MoreStockContext.Provider value={{ setMoreData, data }}>
      {children}
    </MoreStockContext.Provider>
  );
};
export const useMoreStockContext = () => useContext(MoreStockContext);
